// 3) Pokud je allowMultipleInstitutions rovno FALSE, nesmi byt pres vsechny datasety vybrane ReportSubmissionGroups od vice nez jedne InstitutionId
const validateInstitutionUniqueness = (datasets, allowMultipleInstitutions, errorMessage) => {
  if (!allowMultipleInstitutions && datasets && datasets.length > 0) {
    let institutionId = 0
    for (let x = 0; x < datasets.length; x++) {
      for (let y = 0; y < datasets[x].reportSubmissionGroups.length; y++) {
        const reportSubmissionGroup = datasets[x].reportSubmissionGroups[y]
        if (institutionId === 0) {
          institutionId = reportSubmissionGroup.institutionId
        } else if (institutionId !== reportSubmissionGroup.institutionId) {
          return errorMessage
        }
      }
    }
  }
  return null
}

export {
  validateInstitutionUniqueness
}



// WEBPACK FOOTER //
// ./src/internal-app/pages/outputReportGenerator/validation/validateInstitutionUniqueness.js